<template>
  <div class="chat-block-container">
    <template v-if="block.type === 'file'">
      <h4>קובץ מצורף
        <v-btn
          v-if="shouldShow(['ADMIN', 'RESEARCHER'], user)"
          icon
          small
          class="ma-0 pa-0"
          @click="attachFileDialog = true"
        >
          <v-icon small>mdi-account-plus</v-icon>
        </v-btn>
      </h4>
      <a
        :href="secureUrl(block.data.url)"
        target="_blank"
      >{{ block.data.originalFilename || 'ללא שם' }}</a>
      <img :src="secureUrl(block.data.url)" width="100%" max-width="50px" max-height="50px"/> 
      <v-dialog
        v-model="attachFileDialog"
        :fullscreen="$vuetify.breakpoint.smAndDown"
        max-width="500px"
        scrollable
      >
        <v-card v-if="attachFileDialog">
          <v-toolbar
            dark
            flat
            color="secondary"
            scrollable
          >
            <v-btn
              icon
              dark
              @click.native="attachFileDialog = false"
            >
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>שידוך קובץ לספק</v-toolbar-title>
            <v-spacer />
            <v-btn
              flat
              :loading="attaching"
              :disabled="attaching"
              @click="attachFileToPartner"
            >בצע</v-btn>
          </v-toolbar>
          <v-card-text>
            <v-form
              ref="form"
              v-model="valid"
              lazy-validation
            >
              <v-text-field
                disabled
                label="קובץ"
                :value="block.data.originalFilename || 'ללא שם'"
              ></v-text-field>
              <v-select
                :items="eventPartners"
                v-model="selectedPartner"
                item-text="name"
                item-value="_id"
                label="ספק"
                :rules="[v => !!v || 'יש לבחור ספק']"
              ></v-select>
              <v-textarea
                label="תיאור הקובץ"
                height="100px"
                no-resize
                v-model="fileDescription"
                value=""
                hint="למשל: חשבונית"
              ></v-textarea>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>

    </template>
    <template v-if="block.type === 'image'">
      <h4>תמונה מצורפת</h4>
      <a
        :href="secureUrl(imageUrlFromData({ data: block.data, isThumbnail: false }))"
        target="_blank"
      >
        <v-img
          max-width="200px"
          max-height="200px"
          :src="secureUrl(imageUrlFromData({ data: block.data, isThumbnail: true }))"
        /></a>
    </template>
  </div>
</template>

<script>
import shouldShow from "@/utils/shouldShow";
import { getApi } from "@/api";
import { setTimeout } from "timers";

export default {
  data() {
    return {
      attachFileDialog: false,
      attaching: false,
      selectedPartner: null,
      fileDescription: "",
      valid: true
    };
  },

  computed: {
    user() {
      return this.$store.getters["user/user"];
    },
    eventId() {
      return this.$route.params.id;
    },
    event() {
      return this.$store.getters["entity"]("events", this.eventId);
    },
    eventPartners() {
      if (this.event) {
        let partners = this.$store.state.entities.partners;
        return this.event.partners.map(item => {
          let id = item ? item._id || item : null;
          if (id) {
            return partners[id];
          }
        });
      }
      return [];
    }
  },

  methods: {
    shouldShow,
    resetFileAttachDialog() {
      (this.fileDescription = ""), (this.selectedPartner = null);
    },
    attachFileToPartner() {
      if (this.$refs.form.validate()) {
        this.attaching = true;

        let { filename, filetype, originalFilename, url } = this.block.data;
        let params = {
          event: this.eventId,
          partner: this.selectedPartner,
          description: this.fileDescription,
          filename,
          filetype,
          originalFilename,
          url
        };
        getApi()
          .then(api => {
            return api.post("/partner-event-files", params);
          })
          .then(() => {
            this.attachFileDialog = false;
            this.$store.dispatch("SHOW_SNACKBAR", {
              text: "הקובץ שודך בהצלחה",
              color: "success"
            });
          })
          .catch(err => {
            this.$store.dispatch("SHOW_SNACKBAR", {
              text: err.response ? err.response.data.message : err.message,
              color: "error"
            });
          })
          .finally(() => {
            this.attaching = false;
          });
      }
    },
    imageUrlFromData({ data, isThumbnail }) {
      if (data.url) {
        return data.url;
      } else if (data.filename) {
        let baseUrl = "https://cdn1.rescue-1.co.il/";
        if (isThumbnail) {
          baseUrl += "400x300_fit_90/";
        } else {
          baseUrl += "originals/";
        }
        return baseUrl + data.filename;
      }
    },
    secureUrl(url) {
      if (!url) return url;
      return url.replace(/^http:/, 'https:');
    }
  },

  watch: {
    attachFileDialog: function(val) {
      if (!val) {
        this.resetFileAttachDialog();
      }
    }
  },

  components: {},

  props: ["block"]
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.chat-block-container {
  border-right: 3px #ccc solid;
  border-radius: 0 !important;
  padding-right: 10px;
  margin-top: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/chat/Block.vue